<template>
  <div class="home">
    <common-header></common-header>
    <img src="../img/m/progress2.png" alt="" class="progress">
    <div class="page_content">
      <div class="price_item" :class="{'price_item_2': v[0].award_title == '优秀奖'}" v-for="(v, i) in dataList" :key="i">
        <img :src="require('../img/m/'+priceMap[v[0].award_title]+'.png')" alt="" class="price_title" :class="'price_title'+v[0].award_title">
        
        <van-swipe :initial-swipe="0" @change="onChange0" v-if="v[0].award_title != '优秀奖' && i == 0">
          <van-swipe-item v-for="(item, index) in v" :key="index" @click="goDetail(item)">
            <div class="work_con">
              <img :src="'https://collection2021-cos.chineseplus.net/'+item.video_cover" alt="" class="work_cover">
              <div class="work_type">{{item.type == 1 ? '视频' : '图片'}}</div>
              <div class="work_info_con">
                <div class="work_title">{{item.works_title}}</div>
                <div class="author">提供者：{{item.realname}}</div>
                <div class="country">所在国：{{item.cn}}</div>
                <div class="desc">
                  {{item.desc}}
                </div>
              </div>
            </div>
          </van-swipe-item>
          <template #indicator>
            <div class="custom_indicator">{{ current0 + 1 }}/{{v.length}}</div>
          </template>
        </van-swipe>
        <van-swipe :initial-swipe="0" @change="onChange1" v-if="v[0].award_title != '优秀奖' && i == 1">
          <van-swipe-item v-for="(item, index) in v" :key="index" @click="goDetail(item)">
            <div class="work_con">
              <img :src="'https://collection2021-cos.chineseplus.net/'+item.video_cover" alt="" class="work_cover">
              <div class="work_type">{{item.type == 1 ? '视频' : '图片'}}</div>
              <div class="work_info_con">
                <div class="work_title">{{item.works_title}}</div>
                <div class="author">提供者：{{item.realname}}</div>
                <div class="country">所在国：{{item.cn}}</div>
                <div class="desc">
                  {{item.desc}}
                </div>
              </div>
            </div>
          </van-swipe-item>
          <template #indicator>
            <div class="custom_indicator">{{ current1 + 1 }}/{{v.length}}</div>
          </template>
        </van-swipe>
        <van-swipe :initial-swipe="0" @change="onChange2" v-if="v[0].award_title != '优秀奖' && i == 2">
          <van-swipe-item v-for="(item, index) in v" :key="index" @click="goDetail(item)">
            <div class="work_con">
              <img :src="'https://collection2021-cos.chineseplus.net/'+item.video_cover" alt="" class="work_cover">
              <div class="work_type">{{item.type == 1 ? '视频' : '图片'}}</div>
              <div class="work_info_con">
                <div class="work_title">{{item.works_title}}</div>
                <div class="author">提供者：{{item.realname}}</div>
                <div class="country">所在国：{{item.cn}}</div>
                <div class="desc">
                  {{item.desc}}
                </div>
              </div>
            </div>
          </van-swipe-item>
          <template #indicator>
            <div class="custom_indicator">{{ current2 + 1 }}/{{v.length}}</div>
          </template>
        </van-swipe>
        <van-swipe :initial-swipe="0" @change="onChange3" v-if="v[0].award_title != '优秀奖' && i == 3">
          <van-swipe-item v-for="(item, index) in v" :key="index" @click="goDetail(item)">
            <div class="work_con">
              <img :src="'https://collection2021-cos.chineseplus.net/'+item.video_cover" alt="" class="work_cover">
              <div class="work_type">{{item.type == 1 ? '视频' : '图片'}}</div>
              <div class="work_info_con">
                <div class="work_title">{{item.works_title}}</div>
                <div class="author">提供者：{{item.realname}}</div>
                <div class="country">所在国：{{item.cn}}</div>
                <div class="desc">
                  {{item.desc}}
                </div>
              </div>
            </div>
          </van-swipe-item>
          <template #indicator>
            <div class="custom_indicator">{{ current3 + 1 }}/{{v.length}}</div>
          </template>
        </van-swipe>
        <van-swipe :initial-swipe="0" @change="onChange4" v-if="v[0].award_title != '优秀奖' && i == 4">
          <van-swipe-item v-for="(item, index) in v" :key="index" @click="goDetail(item)">
            <div class="work_con">
              <img :src="'https://collection2021-cos.chineseplus.net/'+item.video_cover" alt="" class="work_cover">
              <div class="work_type">{{item.type == 1 ? '视频' : '图片'}}</div>
              <div class="work_info_con">
                <div class="work_title">{{item.works_title}}</div>
                <div class="author">提供者：{{item.realname}}</div>
                <div class="country">所在国：{{item.cn}}</div>
                <div class="desc">
                  {{item.desc}}
                </div>
              </div>
            </div>
          </van-swipe-item>
          <template #indicator>
            <div class="custom_indicator">{{ current4 + 1 }}/{{v.length}}</div>
          </template>
        </van-swipe>
        <ul class="work_con_2" v-if="v[0].award_title == '优秀奖'">
          <li v-for="(item, index) in v" :key="index" @click="goDetail(item)">
            <div class="cover_con">
              <img :src="'https://collection2021-cos.chineseplus.net/'+item.video_cover" alt="" class="cover_img">
            </div>
            <div class="work_type">{{item.type == 1 ? '视频' : '图片'}}</div>
            <div class="work_name">{{item.works_title}}</div>
            <div class="author">提供者：{{item.realname}}</div>
            <div class="country">所在国：{{item.cn}}</div>
          </li>
        </ul>
      </div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import { Notify } from 'vant'
import commonHeader from './common/commonHeader'
import commonFooter from './common/commonFooter'

export default {
  components: {
    commonHeader,
    commonFooter
  },
  data () {
    return {
      dataList: [],
      current0: '',
      current1: '',
      current2: '',
      current3: '',
      current4: '',
      priceMap: {
        '一等奖': '1price',
        '二等奖': '2price',
        '三等奖': '3price',
        '最佳网络人气奖': '4price',
        '优秀奖': '5price',
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    onChange0 (index) {
      console.log(index)
      this.current0 = index
    },
    onChange1 (index) {
      this.current1 = index
    },
    onChange2 (index) {
      this.current2 = index
    },
    onChange3 (index) {
      this.current3 = index
    },
    onChange4 (index) {
      this.current4 = index
    },
    getList () {
      this.$utils.get('/works/get-cert-list').then(res => {
        if(res.code == 1000) {
          this.dataList = res.data
        } else {
        }
      })
    },
    goDetail (v) {
      this.$router.push({
        path: v.type == 1 ? 'm_videoPriceDetail' : '/mpage/m_picPriceDetail',
        query: {
          id: v.works_id
        }
      })
    }
  }
}
</script>

<style lang="scss">
.home {
  .van-swipe {
    padding: 0;
  }
}
</style>

<style scoped lang="scss">
 .home {
   width: 100%;
   margin: 0 auto 0;
   text-align: center;
  //  font-size: 20px;
   text-align: left;
   .progress {
     width: 13.43rem;
     height: 1.26rem;
     display: block;
     margin: auto;
     margin-top: .6rem;
   }
   .page_content {
     box-sizing: border-box;
     width: calc(100% - .9rem);
     margin: auto;
    //  margin-top: 1.15rem;
     position: relative;
     padding: 1.15rem .37rem .38rem .37rem;
     min-height: 12.3rem;
     .price_item {
        background: #fff;
        padding: .3rem .7rem 1rem;
        position: relative;
        margin-bottom: .6rem;
        &.price_item_2 {
          padding: .3rem .36rem 1rem;
        }
        &:last-child {
          &::before {
            display: none;
          }
          &::after {
            display: none;
          }
        }
        &::before {
          content: '';
          display: inline-block;
          background: url('../img/m/connect.png') no-repeat center;
          background-size: 100%;
          width: .37rem;
          height: 1.8rem;
          position: absolute;
          bottom: -1.2rem;
          z-index: 111;
        }
        &::after {
          content: '';
          display: inline-block;
          background: url('../img/m/connect.png') no-repeat center;
          background-size: 100%;
          width: .37rem;
          height: 1.8rem;
          position: absolute;
          bottom: -1.2rem;
          right: .7rem;
          z-index: 111;
        }
        .price_title {
          display: block;
          margin: auto;
          margin-bottom: .3rem;
          width: 2.4rem;
          &.price_title优秀奖 {
            width: 5.55rem;
          }
          &.price_title最佳网络人气奖 {
            width: 4.5rem;
          }
          
        }
        .work_con {
          position: relative;
          .work_cover {
            display: block;
            width: 100%;
            height: 6.81rem;
          }
          .work_type {
            padding: .08rem .16rem;
            background-color: #ff418d;
	          border-radius: 0px .18rem .18rem .18rem;
            font-size: .3rem;
            color: #ffffff;
            position: absolute;
            left: 0;
            top: 0;
          }
          .work_info_con {
            background-color: #e7e0fc;
            padding: .3rem;
            height: 5.7rem;
            .work_title {
              font-size: .6rem;
              font-weight: bold;
              color: #282828;
              margin-bottom: .6rem;
              line-height: 1.4;
            }
            .author {
              font-size: .3rem;
              color: #282828;
              margin-bottom: .15rem;
            }
            .country {
              font-size: .3rem;
              color: #282828;
            }
            .desc {
              font-size: .36rem;
              color: #282828;
              line-height: 1.4;
              margin-top: .4rem;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              word-break: break-word;
              overflow: hidden;
            }
          }
        }
        .work_con_2 {
          li {
            margin-bottom: .4rem;
            display: inline-block;
            background-color: #e7e0fc;
            width: calc((100% - .3rem) / 2);
            position: relative;
            &:nth-child(odd) {
              margin-right: .3rem;
            }
            .cover_con {
              width: 6.23rem;
              width: 100%;
              height: 3.9rem;
              position: relative;
              .cover_img {
                width: 100%;
                height: 100%;
                display: block;
              }
            }
            .work_type {
              padding: .08rem .16rem;
              background-color: #ff418d;
              border-radius: 0px .18rem .18rem .18rem;
              font-size: .3rem;
              color: #ffffff;
              position: absolute;
              left: 0;
              top: 0;
            }
            .work_name {
              font-size: .56rem;
              color: #212121;
              margin-top: .32rem;
              // width: 6.23rem;
              // width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              padding-left: .27rem;
            }
            .author {
              color: #212121;
              font-size: .4rem;
              margin-top: .2rem;
              padding-left: .27rem;
            }
            .country {
              color: #212121;
              font-size: .4rem;
              margin-top: .15rem;
              padding-left: .27rem;
              padding-bottom: .4rem;
            }
          }
        }
        .custom_indicator {
          color: #999999;
          font-size: .4rem;
          font-family: AdobeHeitiStd-Regular;
          text-align: center;
          margin-top: .3rem;
        }
     }
   }
 }
 </style>